import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from "react-router-dom";
import "../Diagnostic/PackageDetail.css";
import WatchLaterOutlinedIcon from '@mui/icons-material/WatchLaterOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import EastOutlinedIcon from '@mui/icons-material/EastOutlined';
import PersonIcon from '@mui/icons-material/Person';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import WhyTrust from '../layout/WhyTrust';

export default function CheckOut() {
  const [bookingInfo, setBookingInfo] = useState({
    patientName: "Manoj Deshmukh",
    phone: "+91-9876541238",
    email: "manoj@gmail.com",
    address: "15 Corner, Sector 10 Shopping Center Jaipur, Rajasthan, 302020",
    visitDate: "April 31 2026",
    visitTime: "07:00 AM",
    visitCharge: 500,
    gst: 25,
    totalAmount: 525
  });

  useEffect(() => {
    const savedDetails = localStorage.getItem("icuBookingDetails");
    if (savedDetails) {
      try {
        const parsed = JSON.parse(savedDetails);
        setBookingInfo(prev => ({
          ...prev,
          ...parsed
        }));
      } catch (e) {
        console.error("Error parsing icuBookingDetails", e);
      }
    }
  }, []);

  return (
    <>
      <Header />

      <div className="test_bredcum_sec">
        <div className="container-fluid">
          <div className="test_bredcum">
            <Link to="/">Home</Link>
            <span>&gt;</span>
            <span className='name_p'>CheckOut</span>
          </div>
        </div>
      </div>

      <div className="checkout_main_pg">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-7">
              <div className="patient-info_checkout booking_box">
                <h3>Patient Information</h3>
                <div className="patient-info_checkout-mian">
                  <div className="info_icon_patient">
                    <div className="icon_info_pat">
                      <PersonIcon />
                      <span>Name</span>
                    </div>
                    <h5>{bookingInfo.patientName}</h5>
                  </div>

                  <div className="info_icon_patient withbackground">
                    <div className="icon_info_pat">
                      <LocalPhoneIcon />
                      <span>Phone Number</span>
                    </div>
                    <h5>{bookingInfo.phone}</h5>
                  </div>

                  <div className="info_icon_patient">
                    <div className="icon_info_pat">
                      <EmailOutlinedIcon />
                      <span>Email</span>
                    </div>
                    <h5>{bookingInfo.email || "N/A"}</h5>
                  </div>

                  <div className="info_icon_patient withbackground">
                    <div className="icon_info_pat">
                      <LocationOnIcon />
                      <span>Address</span>
                    </div>
                    <h5>{bookingInfo.address}</h5>
                  </div>

                  <div className="info_icon_patient">
                    <div className="icon_info_pat">
                      <CalendarMonthOutlinedIcon />
                      <span>Date</span>
                    </div>
                    <h5>{bookingInfo.visitDate}</h5>
                  </div>

                  <div className="info_icon_patient withbackground">
                    <div className="icon_info_pat">
                      <WatchLaterOutlinedIcon />
                      <span>Time</span>
                    </div>
                    <h5>{bookingInfo.visitTime}</h5>
                  </div>

                  <div className="info_icon_patient">
                    <div className="icon_info_pat">
                      <PersonIcon />
                      <span>Booking For</span>
                    </div>
                    <h5>Myself</h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="for_sticky_section">
                <div className="summary_sec booking_box">
                  <h3>Summary</h3>
                  <div className="price_booking">
                    <div className="name_price_booking">
                      <h4>Home Visit Charge</h4>
                      <h5>₹{bookingInfo.visitCharge || 500}</h5>
                    </div>
                    <div className="name_price_booking">
                      <h4>GST(5%)</h4>
                      <h5>₹{bookingInfo.gst || 25}</h5>
                    </div>
                  </div>
                  <div className="total_price_booking ">
                    <h4>Total Payable</h4>
                    <h5>₹ {bookingInfo.totalAmount || 525}</h5>
                  </div>
                </div>

                <div className="policy-btn-box booking_box summary_sec">
                  <div className="icon_content_pb">
                    <VerifiedUserOutlinedIcon />
                    <div>
                      <h5>Your payment is Safe & Secure</h5>
                      <p>Easy cancellation & 100% refund on eligible cancellations.</p>
                    </div>
                  </div>
                  <div className="police_btn_booking">
                    <Link to="/privacy-policy">
                      View Policy <KeyboardArrowRightOutlinedIcon />
                    </Link>
                  </div>
                </div>

                <div className="total_payble booking_box total_amount_cot">
                  <div className="text_payble">
                    <p>Total Amount</p>
                    <h5>₹ {bookingInfo.totalAmount || 525}/-</h5>
                    <p>(Inclusive of all taxes)</p>
                  </div>
                  <div className="book_now_payble">
                    <Link to="/thankyou">Book Now <EastOutlinedIcon /></Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <WhyTrust />
      </div>

      <Footer />
    </>
  );
}
